import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class TitleFlow extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        console.log('tttt==', content);
        const titleList = content.map((currentTitle, index) => {
            let timeSpan = '';

            if (currentTitle.time) {
                timeSpan = <span>{currentTitle.time}</span>;
            }

            return (
                <li key={index} className={styles.titleFlow}>
                    <a href={currentTitle.url} target="_blank" rel="noopener noreferrer">
                        {currentTitle.title}
                    </a>
                    {timeSpan}
                </li>
            );
        });

        return content.length > 0 ? titleList : null;
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
TitleFlow.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
TitleFlow.defaultProps = {};

export default TitleFlow;
